import { isString } from "radash";

const extractIds = (str) => {
  if (!isString(str) || str.length === 0) return [];

  return str.split(",").map((v) => parseInt(v, 10));
};

export { extractIds };
